























import { Vue, Component } from 'vue-property-decorator'
import { NavItem } from './typescript/types'

@Component
export default class App extends Vue {
  private navShow: boolean = false
  private navs: NavItem[] = [
    { icon: 'mdi-home', text: 'Home', link: '/' },
    { icon: 'mdi-newspaper-variant', text: 'News', link: '/news' },
    { icon: 'mdi-sword', text: 'Roles', link: '/roles' },
    { icon: 'mdi-timeline-text', text: 'Roadmap', link: '/roadmap' },
    // { icon: 'mdi-developer-board', text: 'Dev Tracker', link: '/development' },
    { icon: 'mdi-comment-question', text: 'FAQ', link: '/faq' },
    { icon: 'mdi-gamepad-variant', text: 'Play Alpha Preview', link: 'https://happy-turing-797997.netlify.app/' }
    // { icon: 'mdi-at', text: 'Contact', link: '/contact' },
  ]

  mounted () {
    if (window.innerWidth < 600) this.$store.commit('SET_MOBILE', true)
    else this.$store.commit('SET_MOBILE', false)

    window.addEventListener('resize', () => {
      if (window.innerWidth < 600) this.$store.commit('SET_MOBILE', true)
      else this.$store.commit('SET_MOBILE', false)
    })
  }

  private route (link: string): void {
    if (/https/g.test(link)) window.open(link)
    else if (this.$route.path !== link) this.$router.push(link)
  }
}
